import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { thickStroke } from '@/primary/webmapping/country/style/CountryStyle';

export const createCountrySelectionVectorLayer = (): VectorLayer => {
  return new VectorLayer({ source: new VectorSource({ features: [] }), style: thickStroke });
};
